import { FC, memo, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipGroup, TooltipGroupAnchor } from '@/components/shared/tooltip/TooltipGroup';
import { CopyElementIcon } from '@/components/base/Icons/CopyElementIcon';
import IconButton from '@/storybook/components/IconButton/IconButton';

import { TestIds } from './testIds';
import styles from './AIBubble.module.css';

interface AIBubbleDefaultActionsProps {
  onCopy: () => void;
}

const AIBubbleDefaultActions: FC<AIBubbleDefaultActionsProps> = ({ onCopy }) => {
  const { t } = useTranslation();
  const tooltipGroupId = useId();

  return (
    <TooltipGroup id={`ai-bubble-actions-${tooltipGroupId}`} shouldShowForTruncatedOnly={false} delayShow={200}>
      <TooltipGroupAnchor value={t('components.aiChatDrawer.aiBubble.copyTooltip')} place="top" forceDisplayTooltip>
        <span className={styles.actionTooltipAnchor}>
          <IconButton
            appearance="text"
            size="S"
            icon={<CopyElementIcon className={styles.actionIcon} />}
            className={styles.copyButton}
            onClick={onCopy}
            aria-label={t('components.aiChatDrawer.aiBubble.copyAriaLabel')}
            data-testid={TestIds.copyButton}
          />
        </span>
      </TooltipGroupAnchor>
    </TooltipGroup>
  );
};

export default memo(AIBubbleDefaultActions);
